import React from 'react';
import PropTypes from 'prop-types';
import Badge from './BadgeWrapper';

const BadgeGroup = ({ vehicleBadges }) => {
	return (
		// With list-unstyled class, we need to add role="list" for Safari
		// https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility
		// eslint-disable-next-line jsx-a11y/no-redundant-roles
		<ul
			className="d-flex list-unstyled mb-0 align-items-center flex-wrap "
			role="list"
			data-location="vehicle-badge"
		>
			{vehicleBadges.map((badge) => (
				<Badge key={`badge-${badge?.imageSrc}`} {...badge} />
			))}
		</ul>
	);
};

BadgeGroup.propTypes = {
	vehicleBadges: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default BadgeGroup;
